<div class="mdc-layout-grid">
  <form class="data-container mdc-layout-grid__inner" [formGroup]="createLeadFormGroup" #form="ngForm">
    <div class="section-title mdc-layout-grid__cell mdc-layout-grid__cell--span-12">Lead-Source</div>
    <mat-form-field class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet">
      <mat-select formControlName="leadSource" aria-label="Lead Source" required data-test="leadSource">
        <mat-option *ngFor="let leadSource of leadSources | async" [value]="leadSource.id">
          {{leadSource.name}}
          <span *ngIf="leadSource.leadType === 'EXTERNAL_TO_TENANT'">(extern)</span>
        </mat-option>
      </mat-select>
      <mat-label>Lead-Source</mat-label>
    </mat-form-field>

    <mat-form-field class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet">
      <mat-select formControlName="productForm" aria-label="Product Form" required data-test="productForm">
        <mat-option *ngFor="let productForm of productForms" [value]="productForm.platformProductId">
          {{productForm.id}}
        </mat-option>
      </mat-select>
      <mat-label>Product-Form</mat-label>
    </mat-form-field>

    <div *ngIf="getProductFields().controls.length" class="section-title mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
      Lead-Daten
    </div>
    <ng-container formArrayName="productFields">
      <mat-form-field *ngFor="let field of formFields; let i = index"
                         class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet">
        <input type="text" matInput [formControlName]="i">
        <mat-label>
          {{field.displayName}} ({{field.displayDescription}})
        </mat-label>
      </mat-form-field>
    </ng-container>

    <ng-container formArrayName="coApplicantFields">
      <ng-container [formGroupName]="i" *ngFor="let item of this.getCoApplicantFields().controls; let i = index">
        <div class="section-title mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
          Mitantragsteller {{i + 1}}
        </div>
        <ng-container formArrayName="coApplicant">
          <mat-form-field *ngFor="let field of coApplicantFormFields; let j = index"
                          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet">
            <input type="text" matInput [formControlName]="j">
            <mat-label>
              {{field.displayName.replace('*', '' + (i + 1))}}
              ({{field.displayDescription}})
            </mat-label>
          </mat-form-field>
        </ng-container>

      </ng-container>
    </ng-container>

    <div class="section-title mdc-layout-grid__cell mdc-layout-grid__cell--span-12"></div>

    <app-spinner-button
      class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet"
      data-test="create-new-contact-button"
      (click)="onCreateClick()"
      [active]="isValid() && !isCreatingLead"
      [showSpinner]="isCreatingLead">
      LEAD ANLEGEN
    </app-spinner-button>

    <button mat-flat-button
            class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-3-tablet"
            [disabled]="this.formFields.length === 0"
            (click)="onFillOutClick()">
      + BEISPIEL
    </button>

    <button mat-flat-button
            class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-3-tablet"
            [disabled]="this.formFields.length === 0"
            (click)="onAddCoApplicant()">
      + MITANTRAGSTELLER
    </button>

    <button mat-flat-button
            class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-2-tablet"
            [disabled]="this.formFields.length === 0"
            (click)="onResetClick()">
      ZURÜCKSETZEN
    </button>
  </form>
</div>
